import React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import { PodcastLandingPageWithRouter } from './PodcastLandingPage';

type Props = RouteComponentProps<{ podcastId: string }>;

export function Podcast(props: Props) {
  return (
    <Switch>
      <Route
        path={props.match.url}
        render={routeProps => (
          <PodcastLandingPageWithRouter
            data-qa="podcast-landing-page"
            podcastId={props.match.params.podcastId}
            {...routeProps}
          />
        )}
      />
    </Switch>
  );
}
